module.exports = __webpack_public_path__ + "media/packs/images/markers/pod-206ecfbda72e3726d5f8801e7a304110.svg";